export function extractIdFromBase64Hash(hash: string): string {
  const buffer = Buffer.from(hash, 'base64')
  const originalValuesStr = buffer.toString('utf-8')
  const originalValueKeyValueArray: [string, string] =
    JSON.parse(originalValuesStr)
  const [, value] = originalValueKeyValueArray
  return value
}
